import React, { Fragment } from 'react'
import cx from 'classnames'
import Link from 'components/ui/Link/Link'

import s from './ToggleList.scss'


const ToggleList = ({ className, links }) => (
  <div className={cx(s.wrapper, className)}>
    <div className={s.container}>
      {
        links.map(({ title, icon, to, toOLD, onClick }, index) => (
          <Link
            key={index}
            className={s.link}
            to={to}
            toOLD={toOLD}
            target={toOLD ? '_blank' : null}
            onClick={onClick}
          >
            {
              Boolean(icon) ? (
                <Fragment>
                  <span className={s[icon]} /> {title}
                </Fragment>
              ) : (
                title
              )
            }
          </Link>
        ))
      }
    </div>
  </div>
)


export default ToggleList
